import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    dataArray: [],
    message: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.DISCOUNT_PRICE_REQUEST:
      return {
        ...state,
        data: {},
        dataArray: [],
        isProgress: true,
        message: "",
        error: null,
      };
    case homeConstants.DISCOUNT_PRICE_UPDATE:
      return {
        ...state,
        data: action.data,
      };
    case homeConstants.DISCOUNT_PRICE_SUCCESS:
      return {
        data:
          action.response.data && action.response.data?.priceList ? {} : null,
        isProgress: false,
        dataArray:
          action.response.data && action.response.data?.priceList
            ? action.response.data.priceList
            : [],
        message: action.response.message,
        success: action.response.success,
        error: null,
      };
    case homeConstants.DISCOUNT_PRICE_FAILURE:
      return {
        data: {},
        dataArray: [],
        error: action.error,
        isProgress: false,
        success: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
        dataArray: [],
        message: "",
        error: null,
      };
    default:
      return state;
  }
}
